<div class="modal fade" id="leadModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <app-matloader *ngIf="leadFormLoader"></app-matloader>
            <div class="contact-dealer-form" *ngIf="contactFormShow">
                <button type="button" class="close" data-dismiss="modal"><i class="ti-close"></i></button>
                <form class="validate-form" (ngSubmit)="sendOtpForLead()" [formGroup]="leadFormData">
                    <span class="login100-form-title">Contact to Propira Team</span>
                    <span [innerHtml]="leadFormMsg"></span>
                    <!-- <div class="wrap-input100" style="display: block;">
                        <label style="margin-right: 0;">Are you a property dealer</label>
                        <div class="row owner-type" style="margin: 0;">
                            <ul>
                                <li>
                                    <label for="dealer-yes" class="switch">
                                        <input type="radio" formControlName="dealer_have" id="dealer-yes" value="1"
                                            required>
                                        <span class="iam round">Yes</span>
                                    </label>
                                </li>
                                <li>
                                    <label for="dealer-no" class="switch">
                                        <input type="radio" formControlName="dealer_have" id="dealer-no" value="0"
                                            required>
                                        <span class="iam round">No</span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                    <div class="wrap-input100">
                        <input class="input100" type="text" formControlName="contact_name" onkeypress="return (event.charCode > 64 && 
                        event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode==32"
                            placeholder="Contact Name" required>
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-user" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="leadFormValid && leadFormDataControl.contact_name.errors">
                            <p class="error" *ngIf="leadFormDataControl.contact_name.errors.required">Enter your name
                            </p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="email" formControlName="contact_email" placeholder="Email">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-email" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="leadFormValid && leadFormDataControl.contact_email.errors">
                            <p class="error"
                                *ngIf="(leadFormDataControl.contact_email.errors.email)">
                                Enter valid email id</p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="tel" formControlName="contact_mobile" placeholder="Mobile"
                            (keypress)="numberOnly($event,10)">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-mobile" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="leadFormValid && leadFormDataControl.contact_mobile.errors">
                            <p class="error"
                                *ngIf="(leadFormDataControl.contact_mobile.errors.required || leadFormDataControl.contact_mobile.errors.pattern)">
                                Enter valid Mobile No</p>
                        </span>
                    </div>
                    <!-- <div class="wrap-input100">
                        <input class="input100" type="text" formControlName="address" placeholder="Address" required>
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-pencil" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="leadFormValid && leadFormDataControl.address.errors">
                            <p class="error" *ngIf="leadFormDataControl.address.errors.required">Enter Address</p>
                        </span>
                    </div> -->
                    <div class="txt2 wrap-input100">
                        <input formControlName="terms_cond" type="checkbox" [checked]="isChecked"> &nbsp;By
                        submitting I accept Propira &nbsp;<a target="_blank" href="term-condition">Terms and
                            Conditions</a>
                        <!-- <span class="error-msg" *ngIf="leadFormValid && leadFormDataControl.terms_cond.errors">
                            <p class="error" *ngIf="leadFormDataControl.terms_cond.errors.required">Please check the
                                Terms and Conditions</p>
                        </span> -->
                    </div>
                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" type="submit">Submit</button>
                    </div>
                </form>
            </div>
            <div class="contact-dealer-thanks" *ngIf="otpFormShow">
                <button type="button" class="close" data-dismiss="modal"><i class="ti-close"></i></button>
                <form method="POST" #otpForm="ngForm" (ngSubmit)="submitContact(otpForm)">
                    <div class="row otpVerify" style="margin: 0;">
                        <div class="wrap-input100">
                            <span [innerHtml]="leadFormMsg"></span>
                        </div>
                        <div class="wrap-input100">
                            <label class="text-center">OTP has been sent to your mobile XXXXXX{{ showOtpMobileNo }},
                                please enter same here to verify.</label>
                        </div>
                        <div class="wrap-input100 col-md-12" style="padding: 0;justify-content: center;">
                            <div class="wrap-input100 col-md-3 col-4" style="padding: 0;">
                                <input class="input100 change" type="tel" name="pass1" maxlength="1" size="1" required
                                    id="pass1" ngModel  #pass1="ngModel">
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 col-md-3 col-4" style="padding: 0;">
                                <input class="input100 change" type="tel" name="pass2" maxlength="1" size="1" required
                                    id="pass2" ngModel  #pass2="ngModel">
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 col-md-3 col-4" style="padding: 0;">
                                <input class="input100 change" type="tel" name="pass3" maxlength="1" size="1" required
                                    id="pass3" ngModel  #pass3="ngModel">
                                <span class="focus-input100"></span>
                            </div>
                            <span class="focus-input100"></span>
                            <span class="error-msg" style="left:-43px;bottom:0;" *ngIf="errorMessage">
                                <p class="error">Enter otp here</p>
                            </span>
                        </div>
                        <p class="one_time_password text-danger" (click)="sendOtpForLead()"
                        style="cursor:pointer;margin:0px;margin-top:-5px;font-size: 12px;float:right;display: flex;justify-content: end;width: 100%;">RESEND
                        (OTP)</p>
                        <div class="container-login100-form-btn">
                            <button class="login100-form-btn" type="submit">Verify</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="contact-dealer-thanks" *ngIf="thankYouFormShow">
                <button type="button" class="close" data-dismiss="modal"><i class="ti-close"></i></button>
                <div class="thanks-msg">
                    <img src="assets/images/contact-thanks-image.png" class="img-fluid" alt="thank you">
                    <span class="login100-form-title">Thank You</span>
                    <span [innerHtml]="leadFormMsg">
                    </span>
                </div>
                <div>
                    <div class="login100-pic">
                        <img src="assets/images/thanku.jpg" alt="IMG">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>